<template>
      <el-dialog custom-class="yearDialog" :visible.sync="dialogTableVisible" width="500px" :show-close="false" append-to-body :before-close="handleDialogClose">
            <div class="bigTitle">岗位描述</div>
            <div v-html="jobReqTxt"></div>
      </el-dialog>
</template>
<script>
export default {
      components:{
      },
      data(){
        return{
           jobReqTxt:'',//岗位描述
           dialogTableVisible:false,
        }
      },
      mounted(){
      },
      methods:{
            handleDialogClose(){
                        this.dialogTableVisible = false
            },
            showDialog(txt){
                  this.dialogTableVisible = true
                  this.jobReqTxt = txt
            },
      }
}
</script>
<style scoped lang="scss">
::v-deep{
     .yearDialog{
      //      height: 600px;
           overflow-y: scroll;
           border-radius: 4px;
           scrollbar-width: none; //兼容火狐浏览器
           &::-webkit-scrollbar{width: 0;display: none;}
           &::-webkit-scrollbar-track{width: 0;display: none;}
           &::-webkit-scrollbar-thumb{width: 0;display: none;}
           &::-webkit-scrollbar-button{width: 0;display: none;}
           &::-webkit-scrollbar-corner{width: 0;display: none;}
           .yearbox{
                 margin-bottom: 74px;
           }
         .el-dialog__header{
               display: none;
         }
         .el-dialog__body{
           padding-right: 32px;
           padding-left: 32px;
           box-sizing: border-box;
         }
         .bigTitle{
               font-weight: 500;
            color: #333333;
            line-height: 33px;
            font-size: 24px;
            text-align: center;
            margin-bottom: 24px;
         }
   }
}
</style>